import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Exige que la valeur saisie corresponde exactement a `expected`, a la casse et
 * aux espaces de bord pres. Utilise pour confirmer une action irreversible.
 */
export function ExactMatchValidator(expected: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').toString().trim();

    if (!value) {
      return null;
    }

    return value.toLowerCase() === (expected ?? '').trim().toLowerCase() ? null : { exactMatch: true };
  };
}
